import { Button } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';

type ButtonProps = ComponentProps<typeof Button>;

export const LoadMoreButton = ({
  onClick,
  label = 'Load More Reviews',
}: Pick<ButtonProps, 'onClick'> & { label?: string }) => {
  return (
    <Button
      className="w-[full] bg-generic-0 text-primary-500 rounded-[8px] border font-normal text-label-medium"
      variant="outline"
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

export default LoadMoreButton;
